import React from 'react'
import LimitCard from './LimitCard'

const MIN_OPTIONS = [5, 4]

const SetMinPlayerValue = (props) => (
  <LimitCard
    field="min_limit"
    limitType="min"
    title="Minimum Value"
    note="Add cheaper values below the default range."
    current={props.advanceMinPlayerprice}
    edge={props.defaultLow}
    options={MIN_OPTIONS}
    symbol={props.symbol}
    requiredMessage="Min Limit is required"
    fetchData={props.fetchData}
  />
)

export default SetMinPlayerValue
